import { formatFullName } from '@caresend/utils';
import { defineComponent, computed, ref, watch } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$1 from '../../../../../inputs/DatePicker/DatePicker.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import TransitionExpand from '../../../../../transitions/TransitionExpand/TransitionExpand.js';
import { TagStyle } from '../../../../../ui/Tag/model.js';
import __vue_component__$2 from '../../../../../ui/Tag/Tag.vue.js';
import '@caresend/types';
import 'firebase/auth';
import { trackPatientDOBValidatedRequest } from '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../ui/Icon.vue.js';
import '../../../../../../functions/configuration/icons.js';
import '../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import '../../../../../../router/helpers/initRouter.js';
import { getStore } from '../../../../../../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { showIntercomMessenger } from '../../../../../../functions/intercom.js';

var script = defineComponent({
    name: 'ItineraryWaypointPatientDOB',
    components: {
        BasicCard: __vue_component__,
        DatePicker: __vue_component__$1,
        TransitionExpand,
        Tag: __vue_component__$2,
    },
    model: {
        prop: 'isValid',
        event: 'completed',
    },
    props: {
        waypointActionID: {
            type: String,
            required: true,
        },
    },
    emits: ['completed'],
    setup(props, { emit }) {
        const store = getStore();
        const portalStore = usePortalStore();
        const waypointAction = computed(() => portalStore.waypointActions.get(props.waypointActionID));
        const patient = computed(() => {
            var _a;
            if (!((_a = waypointAction.value) === null || _a === void 0 ? void 0 : _a.computed.singlePatientID))
                return;
            return store.state.users.users[waypointAction.value.computed.singlePatientID];
        });
        const name = computed(() => {
            if (patient.value === undefined)
                return null;
            return formatFullName(patient.value);
        });
        const patientDOB = computed(() => { var _a; return (_a = patient.value) === null || _a === void 0 ? void 0 : _a.info.dateOfBirth; });
        const selectionMessage = ref(null);
        const isValid = ref(false);
        watch(isValid, async () => {
            if (isValid.value) {
                /**
                 * I inserted this here as a temporary solution because we don't
                 * support completion actions on workflow items yet
                 *
                 * migrate to a completion action once these exist
                 */
                trackPatientDOBValidatedRequest({
                    waypointActionID: props.waypointActionID,
                });
                emit('completed');
            }
        });
        const dobInput = ref(isValid.value ? patientDOB.value : undefined);
        watch(() => [dobInput.value, patientDOB.value], () => {
            if (!dobInput.value) {
                selectionMessage.value = null;
                return;
            }
            if (patientDOB.value === dobInput.value) {
                selectionMessage.value = 'Success';
                isValid.value = true;
            }
            else {
                selectionMessage.value = 'Incorrect';
                isValid.value = false;
            }
        }, { immediate: true });
        const selectionMessageIcon = computed(() => isValid.value ? 'check' : 'times');
        const selectionMessageType = computed(() => isValid.value ? TagStyle['3_GREEN'] : TagStyle['3_RED']);
        return {
            name,
            dobInput,
            isValid,
            selectionMessage,
            selectionMessageIcon,
            selectionMessageType,
            showIntercomMessenger,
        };
    },
});

export { script as default };
